import React, { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePager(items, pageSize = 25) {
  const [page, setPage] = useState(1);
  const pages = Math.max(1, Math.ceil(items.length / pageSize));
  useEffect(() => { if (page > pages) setPage(1); }, [pages, page]);
  const pageItems = useMemo(() => items.slice((page - 1) * pageSize, page * pageSize), [items, page, pageSize]);
  return { page, setPage, pages, pageItems, total: items.length };
}

function pageNums(page, pages) {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const out = [1];
  if (page > 3) out.push("…");
  for (let n = Math.max(2, page - 1); n <= Math.min(pages - 1, page + 1); n++) out.push(n);
  if (page < pages - 2) out.push("…");
  out.push(pages);
  return out;
}

export function Pager({ page, pages, total, onPage, testid = "pager" }) {
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between flex-wrap gap-2 px-4 py-2.5 border-t border-neutral-200 bg-white" data-testid={testid}>
      <span className="text-[10px] font-mono uppercase tracking-wider text-neutral-400">{total} records · page {page} of {pages}</span>
      <div className="flex items-center gap-1">
        <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}
          className="p-1.5 rounded-md border border-neutral-200 text-neutral-600 hover:border-neutral-500 disabled:opacity-30 disabled:cursor-not-allowed">
          <ChevronLeft size={13} />
        </button>
        {pageNums(page, pages).map((n, i) => n === "…" ? (
          <span key={`e${i}`} className="px-1.5 text-xs text-neutral-400">…</span>
        ) : (
          <button type="button" key={n} onClick={() => onPage(n)} data-testid={`${testid}-page-${n}`}
            className={`min-w-[28px] px-1.5 py-1 rounded-md text-xs font-semibold ${n === page ? "bg-[#0A0C10] text-white" : "border border-neutral-200 text-neutral-600 hover:border-neutral-500"}`}>
            {n}
          </button>
        ))}
        <button type="button" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}
          className="p-1.5 rounded-md border border-neutral-200 text-neutral-600 hover:border-neutral-500 disabled:opacity-30 disabled:cursor-not-allowed">
          <ChevronRight size={13} />
        </button>
      </div>
    </div>
  );
}
